if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const items = [];

        const mainVariantId = Number(this.form.querySelector('[name="id"]').value);
        const qtyInput = this.form.querySelector('[name="quantity"]');

        items.push({
          id: mainVariantId,
          quantity: qtyInput ? Number(qtyInput.value) : 1,
        });

        const accessoriesContainer = document.querySelector('product-accessories');

        console.log('button', this.submitButton);

        if (accessoriesContainer && !this.submitButton.classList.contains('quick-add__submit')) {
          accessoriesContainer.querySelectorAll('.product-add__checkbox.accessories:checked').forEach((el) => {
            const container = el.closest('product-info');
            const qtyInput = container.querySelector('.product-add__quantity-input.accessories');
            const qty = qtyInput ? Number(qtyInput.value) : 1;
            const select = container.querySelector('.product-complementary__select.product_selector');
            let id = select.value;

            if (!id) {
              id = Number(el.name);
            }

            items.push({
              id: Number(id),
              quantity: qty,
              properties: {
                _accessory: mainVariantId,
              },
            });
          });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items }),
        })
          .then((res) => res.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            }

            const comparedVariantPrice =
              Number(document?.querySelector('product-info [data-price-regular]')?.dataset.priceRegular) || 0;

            if (comparedVariantPrice && !Number.isNaN(comparedVariantPrice)) {
              addComparedVariantPriceToLocalStorage({
                [mainVariantId]: comparedVariantPrice,
              });
            }

            window.ajaxCart.load();

            theme.mfpOpen('cart');

            this.error = false;
          })
          .catch(console.error)
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
